const constants = {
  "API_URL": process.env.REACT_APP_URL || "https://title.mms.gov.ua/api/v1",
  "API_URL-Test": process.env.REACT_APP_URL_TEST || "https://title-dev.mms.gov.ua/api/v1",
  "API_URL_Prod": process.env.REACT_APP_URL_PROD || "https://title.mms.gov.ua/api/v1"
  
}

export default constants;